import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import routes from './routes';
import { instanceNoAuth } from './utils/axios';
import { baseUrl } from './utils/helper';
import { Helmet } from 'react-helmet';

function App() {
  const [setting, setSetting] = useState({});
  const getSetting = async () => {
    try {
      const res = await instanceNoAuth().get('/setting');
      setSetting(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSetting();
  }, []);
  return (
    <Router>
      <div className="App">
        <Helmet>
          <link rel="icon" href={`${baseUrl}${setting.favicon}`} />
        </Helmet>
        <Routes>
          {routes.map((route, index) => {
            const Page = route.component;
            let Layout;
            if (route.layout) {
              Layout = route.layout;
            } else {
              Layout = Fragment;
            }
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <Layout>
                    <Page title={route.title} />
                  </Layout>
                }></Route>
            );
          })}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
